export const environment = {
  production: true, 
  recaptcha: {
    siteKey: '6Lcmw-8qAAAAAHvWmUMGDEWz-s_hbcRpd9SBhpTu',//TO UPDATE AFTER NEW GENERATION V3
  },
  gtag: {
    key:'G-FD4ESVJFDG' //TO UPDATE BEFORE DELIVERY
  }
};
